/**
 * Aggiunge il prefisso `https://` se l'URL non inizia con `http`.
 * Lascia l'input invariato se ha già lo schema.
 *
 * Caso d'uso: campi `domain` salvati in DB come "example.com" che
 * devono diventare URL aprible in `<a href>` o nuova tab. Default
 * a HTTPS perché plain HTTP è ormai eccezione (e i siti che servono
 * solo HTTP fanno redirect).
 */
export function ensureHttpsPrefix(url: string): string {
  return url.startsWith('http') ? url : `https://${url}`;
}
